<template>
  <div class="courseForm fullWidth fCol jStart aCenter">
    <div class="title fRow jSart aCenter fullWidth">
      <i class="material-icons-round">school</i>
      <div class="fCol growFull jCenter aStart fullWidth">
        <div class="t">
          {{editMode ? `ویرایش دورۀ ${editInitData.title}` : 'ایجاد دورۀ آموزشی جدید'}}
        </div>
        <div class="d">
          {{editMode ? `برای ویرایش دوره اطلاعات را تکمیل کنید`
          : 'برای ایجاد دورۀ جدید، مراحل زیر را طی کنید'}}
        </div>
      </div>
      <div class="stepper">{{step}}/{{steps}}</div>
    </div>
    <div class="bar fullWidth fRow jStart aCenter">
      <div class="progress transition-cubic"
        v-bind:style="{width: `${((step) / steps) * 100}%`}"></div>
      <div class="progress done transition-cubic"
        v-bind:style="{width: `${((step - 1) / steps) * 100}%`}"></div>
    </div>
    <div class="fCol jCenter aCenter fullWidth"
      v-if="loading || noContent">
      <p-bar
        :loading="loading"
        :notYet="notYet"
        :noContent="noContent"
        :notFound="notFound"
        :error="error" />
    </div>
    <div class="wizard fullWidth fCol jCenter aCenter" v-if="!loading">
      <!-- step1 -> field -->
      <div class="bigInputHolder fullWidth fCol jCenter aCenter" v-if="step === 1">
        <div class="bigTitle fCol jCenter aCenter">
          <i class="material-icons-round">category</i>
          <div class="t">انتخاب رشتۀ تحصیلی</div>
          <div class="d">جستجو کنید و رشته را انتخاب کنید</div>
        </div>
        <input type="text" class="bigSearch fullWidth"
          v-model="search" placeholder="جستجو کنید...">
        <div class="selectables fRow jCenter aCenter wrap">
          <!-- item -->
          <div class="item fRow jStart aCenter transition-fast"
            @click="selectItem('field', item)"
            v-bind:class="{selected: field.id === item.id}"
            v-for="(item, index) in filteredFields" v-bind:key="index">
            <!-- اگه عکس داشت -->
            <div class="avatar" v-if="item.photo !== undefined"
              v-bind:style="{backgroundImage: `url('${baseURL}/${item.photo}')`}">
            </div>
            <!-- اگه عکس نداشت -->
            <div class="avatar fRow jCenter aCenter" v-if="item.photo === undefined">
              {{item.title.substr(0, 1)}}
            </div>
            <div class="fCol jCenter aStart">
              <label>{{item.title}}</label>
              <!-- <div class="desc">{{item.id}}</div> -->
            </div>
          </div>
          <!-- no content -->
          <div class="noContent fCol jCenter aCenter fullWidth"
            v-if="filteredFields.length === 0">
            <i class="material-icons-round">error</i>
            <span class="big fullWidth">نتیجه‌ای یافت نشد</span>
            <span class="mini fullWidth">جستجوی شما نتیجه‌ای در بر نداشت، در صورت نیاز
              رشتۀ مورد نظر را <a href="/fields" class="inline">از اینجا</a> ثبت کنید
            </span>
            <div class="clearFilter"
              v-if="search.length > 0"
              @click="search = ''">
              حذف جستجوی «{{search}}»
            </div>
          </div>
        </div>
        <div class="fRow jCenter aCenter fullWidth">
          <div class="bt fRow jCenter aCenter"
            @click="goGet('grade')"
            v-bind:class="{active: !fieldErr}">
            <!-- <i class="material-icons-round">keyboard_arrow_right</i> -->
            <label>مرحلۀ بعدی - انتخاب پایۀ تحصیلی</label>
          </div>
          <!-- <div class="b fRow jCenter aCenter big">
            <i class="material-icons-round">keyboard_arrow_left</i>
          </div> -->
        </div>
      </div>
      <!-- step2 -> grade -->
      <div class="bigInputHolder fullWidth fCol jCenter aCenter" v-if="step === 2">
        <div class="bigTitle fCol jCenter aCenter">
          <i class="material-icons-round">category</i>
          <div class="t">انتخاب پایۀ تحصیلی</div>
          <div class="d">بین پایه‌های رشتۀ {{field.title}} جستجو کنید و پایه را انتخاب کنید</div>
        </div>
        <input type="text" class="bigSearch fullWidth"
          v-model="search" placeholder="جستجو کنید...">
        <div class="selectables fRow jCenter aCenter wrap">
          <!-- item -->
          <div class="item fRow jStart aCenter transition-fast"
            @click="selectItem('grade', item)"
            v-bind:class="{selected: grade.id === item.id}"
            v-for="(item, index) in filteredGrades" v-bind:key="index">
            <!-- اگه عکس داشت -->
            <div class="avatar" v-if="item.photo !== undefined"
              v-bind:style="{backgroundImage: `url('${baseURL}/${item.photo}')`}">
            </div>
            <!-- اگه عکس نداشت -->
            <div class="avatar fRow jCenter aCenter" v-if="item.photo === undefined">
              {{item.title.substr(0, 1)}}
            </div>
            <div class="fCol jCenter aStart">
              <label>{{item.title}}</label>
              <div class="desc">{{field.title}}</div>
            </div>
          </div>
          <!-- no content -->
          <div class="noContent fCol jCenter aCenter fullWidth"
            v-if="filteredGrades.length === 0">
            <i class="material-icons-round">error</i>
            <span class="big fullWidth">نتیجه‌ای یافت نشد</span>
            <span class="mini fullWidth">جستجوی شما نتیجه‌ای در بر نداشت، در صورت نیاز
              پایۀ مورد نظر را <a href="/grades" class="inline">از اینجا</a> ثبت کنید
            </span>
            <div class="clearFilter"
              v-if="search.length > 0"
              @click="search = ''">
              حذف جستجوی «{{search}}»
            </div>
          </div>
        </div>
        <div class="fRow jCenter aCenter fullWidth">
          <div class="bt fRow jCenter aCenter mini"
            @click="goGet('field')">
            <i class="material-icons-round">keyboard_arrow_right</i>
            <label>اصلاح رشته</label>
          </div>
          <div class="bt fRow jCenter aCenter"
            @click="goGet('lesson')"
            v-bind:class="{active: !gradeErr}">
            <label>مرحلۀ بعدی - انتخاب درس</label>
            <i class="material-icons-round">keyboard_arrow_left</i>
          </div>
        </div>
      </div>
      <!-- step3 -> lessons -->
      <div class="bigInputHolder fullWidth fCol jCenter aCenter" v-if="step === 3">
        <div class="bigTitle fCol jCenter aCenter">
          <i class="material-icons-round">category</i>
          <div class="t">انتخاب درس‌ها</div>
          <div class="d">بین درس‌های {{grade.title}} جستجو کنید و درس را انتخاب کنید</div>
        </div>
        <input type="text" class="bigSearch fullWidth"
          v-model="search" placeholder="جستجو کنید...">
        <div class="selectables fRow jCenter aCenter wrap">
          <!-- item -->
          <div class="item fRow jStart aCenter transition-fast"
            @click="selectItem('lesson', item)"
            v-bind:class="{selected: lesson.id === item.id}"
            v-for="(item, index) in filteredLesson" v-bind:key="index">
            <!-- اگه عکس داشت -->
            <div class="avatar" v-if="item.photo !== undefined"
              v-bind:style="{backgroundImage: `url('${baseURL}/${item.photo}')`}">
            </div>
            <!-- اگه عکس نداشت -->
            <div class="avatar fRow jCenter aCenter" v-if="item.photo === undefined">
              {{item.title.substr(0, 1)}}
            </div>
            <div class="fCol jCenter aStart">
              <label>{{item.title}}</label>
              <div class="desc">{{grade.title}}</div>
            </div>
          </div>
          <!-- no content -->
          <div class="noContent fCol jCenter aCenter fullWidth"
            v-if="filteredLesson.length === 0">
            <i class="material-icons-round">error</i>
            <span class="big fullWidth">نتیجه‌ای یافت نشد</span>
            <span class="mini fullWidth">جستجوی شما نتیجه‌ای در بر نداشت، در صورت نیاز
              درس مورد نظر را <a href="/lessons" class="inline">از اینجا</a> ثبت کنید
            </span>
            <div class="clearFilter"
              v-if="search.length > 0"
              @click="search = ''">
              حذف جستجوی «{{search}}»
            </div>
          </div>
        </div>
        <div class="fRow jCenter aCenter fullWidth">
          <div class="bt fRow jCenter aCenter mini" @click="goGet('grade')">
            <i class="material-icons-round">keyboard_arrow_right</i>
            <label>اصلاح پایۀ تحصیلی</label>
          </div>
          <div class="bt fRow jCenter aCenter"
            @click="goGet('teacher')"
            v-bind:class="{active: !lessonErr}">
            <label>مرحلۀ بعدی - انتخاب مدرّس</label>
            <i class="material-icons-round">keyboard_arrow_left</i>
          </div>
        </div>
      </div>
      <!-- step4 -> teacher -->
      <div class="bigInputHolder fullWidth fCol jCenter aCenter" v-if="step === 4">
        <div class="bigTitle fCol jCenter aCenter">
          <i class="material-icons-round">category</i>
          <div class="t">انتخاب مدرّس</div>
          <div class="d">بین مدرس‌های مربوط به درس {{lesson.title}}
            جستجو کنید و درس را انتخاب کنید</div>
        </div>
        <input type="text" class="bigSearch fullWidth"
          v-model="search" placeholder="جستجو کنید...">
        <div class="selectables fRow jCenter aCenter wrap">
          <!-- item -->
          <div class="item fRow jStart aCenter transition-fast"
            @click="selectItem('teacher', item)"
            v-bind:class="{selected: teacher.id === item.id}"
            v-for="(item, index) in filteredTeachers" v-bind:key="index">
            <!-- اگه عکس داشت -->
            <div class="avatar" v-if="item.photo !== undefined"
              v-bind:style="{backgroundImage: `url('${baseURL}/${item.photo}')`}">
            </div>
            <!-- اگه عکس نداشت -->
            <div class="avatar fRow jCenter aCenter" v-if="item.photo === undefined">
              {{item.title.substr(0, 1)}}
            </div>
            <div class="fCol jCenter aStart">
              <label>{{item.title}}</label>
              <div class="desc">{{item.desc.substr(0, 24)}}...</div>
            </div>
          </div>
          <!-- no content -->
          <div class="noContent fCol jCenter aCenter fullWidth"
            v-if="filteredTeachers.length === 0">
            <i class="material-icons-round">error</i>
            <span class="big fullWidth">نتیجه‌ای یافت نشد</span>
            <span class="mini fullWidth">جستجوی شما نتیجه‌ای در بر نداشت، در صورت نیاز
              مدرّس مورد نظر را <a href="/teachers" class="inline">از اینجا</a> ثبت کنید
            </span>
            <div class="clearFilter"
              v-if="search.length > 0"
              @click="search = ''">
              حذف جستجوی «{{search}}»
            </div>
          </div>
        </div>
        <div class="fRow jCenter aCenter fullWidth">
          <div class="bt fRow jCenter aCenter mini" @click="goGet('lesson')">
            <i class="material-icons-round">keyboard_arrow_right</i>
            <label>اصلاح درس</label>
          </div>
          <div class="bt fRow jCenter aCenter"
            @click="goGet('base')"
            v-bind:class="{active: !teacherErr}">
            <label>مرحلۀ بعدی - مشخصات دوره</label>
            <i class="material-icons-round">keyboard_arrow_left</i>
          </div>
        </div>
      </div>
      <!-- step5 -> info -->
      <div class="bigInputHolder fullWidth fCol jCenter aCenter" v-if="step === 5">
        <div class="bigTitle fCol jCenter aCenter">
          <i class="material-icons-round">info</i>
          <div class="t">اطلاعات دوره</div>
          <div class="d">اطلاعات دوره را وارد کنید</div>
        </div>
        <div class="fullWidth form fRow jBetween aCenter wrap">
          <div class="ih fCol jCenter aStart w40">
            <span class="fRow jStart aCenter label"
              v-bind:class="{ready: showErrors && !coverErr}">
              <i class="material-icons-round">photo</i>
              تصویر دوره
            </span>
            <get-photo
              w='100%'
              style="margin-top: -8px"
              v-on:photoupload="getUploaded"
              photoFor='addCourse'
              :initImg='initImage'
              uploadMsg='آپلود تصویر الزامیست'
              uploadLabel='تصویر دوره'/>
          </div>
          <div class="fRow jBetween aCenter w60 wrap">
            <!-- عنوان -->
            <div class="fCol jCenter aStart ih fullWidth">
              <span class="fRow jStart aCenter label"
                v-bind:class="{ready: showErrors && !titleErr}">
                <i class="material-icons-round">title</i>
                عنوان دوره
              </span>
              <input type="text" class="bigSearch fullWidth"
                v-bind:class="{ready: showErrors && !titleErr}"
                v-model="title" placeholder="عنوان دوره">
            </div>
            <!-- قیمت -->
            <div class="fCol jCenter aStart ih w33">
              <span class="fRow jStart aCenter label"
                v-bind:class="{ready: true}">
                <i class="material-icons-round">credit_card</i>
                دوره رایگان است؟
              </span>
              <switch-button
                style="margin: 10px 0"
                activeLabel="رایگان"
                deactiveLabel="غیر رایگان"
                @click.native="free = !free"
                :val="free" />
            </div>
            <!-- قیمت -->
            <div class="fCol jCenter aStart ih w33" v-if="!free">
              <span class="fRow jStart aCenter label"
                v-bind:class="{ready: showErrors && !priceErr}">
                <i class="material-icons-round">credit_card</i>
                قیمت دوره (تومان)
              </span>
              <input type="text" class="bigSearch fullWidth"
                v-bind:class="{ready: showErrors && !priceErr}"
                v-model="price" placeholder="قیمت دوره">
            </div>
            <!-- تخفیف -->
            <div class="fCol jCenter aStart ih w33" v-if="!free">
              <span class="fRow jStart aCenter label"
                v-bind:class="{ready: showErrors && !discountErr}">
                <i class="material-icons-round">local_offer</i>
                تخفیف دوره
              </span>
              <input type="text" class="bigSearch fullWidth"
              v-bind:class="{ready: showErrors && !discountErr}"
                v-model="discount" placeholder="تخفیف دوره %">
            </div>
          </div>
        </div>
        <div class="fRow jCenter aCenter fullWidth">
          <div class="bt fRow jCenter aCenter mini" @click="goGet('lesson')">
            <i class="material-icons-round">keyboard_arrow_right</i>
            <label>اصلاح درس</label>
          </div>
          <div class="bt fRow jCenter aCenter"
            @click="goGet('settings')"
            v-bind:class="{active: baseErr}">
            <label>مرحلۀ بعدی - تنظیمات دوره</label>
            <i class="material-icons-round">keyboard_arrow_left</i>
          </div>
        </div>
      </div>
      <!-- step 6 -> setting -->
      <div class="bigInputHolder fullWidth fCol jCenter aCenter" v-if="step === 6">
        <div class="bigTitle fCol jCenter aCenter">
          <i class="material-icons-round">settings</i>
          <div class="t">تنظیمات دوره</div>
          <div class="d">تنظیمات دوره را وارد کنید</div>
        </div>
        <div class="fullWidth form fRow jBetween aCenter wrap">
          <div class="fRow jBetween aCenter fullWidth wrap">
            <!-- توضیحات مختصر -->
            <div class="fCol jCenter aStart ih w50">
              <span class="fRow jStart aCenter label"
                v-bind:class="{ready: showErrors && !shortDescErr}">
                <i class="material-icons-round">title</i>
                توضیحات مختصر
              </span>
              <textarea type="text"
                class="bigSearch fullWidth"
                style="text-align: right; min-height: 128px"
                v-bind:class="{ready: showErrors && !shortDescErr}"
                v-model="shortDesc" placeholder="توضیحات محتصر"></textarea>
            </div>
            <!-- مدت دوره -->
            <div class="fCol jCenter aCenter w50">
              <div class="fCol jCenter aStart ih fullWidth">
                <span class="fRow jStart aCenter label"
                  v-bind:class="{ready: showErrors && !durationErr}">
                  <i class="material-icons-round">schedule</i>
                  مدت دوره به ساعت
                </span>
                <input type="number" class="bigSearch fullWidth"
                  style="text-align: right"
                  v-bind:class="{ready: showErrors && !durationErr}"
                  v-model="duration" placeholder="مدت دوره">
              </div>
              <!-- وضعیت -->
              <div class="fCol jCenter aStart ih fullWidth">
                <span class="fRow jStart aCenter label"
                  v-bind:class="{ready: true}">
                  <i class="material-icons-round">credit_card</i>
                  دوره فعال است؟
                </span>
                <switch-button
                  style="margin: 10px 0"
                  activeLabel="فعال"
                  deactiveLabel="غیر فعال"
                  @click.native="status = !status"
                  :val="status" />
              </div>
            </div>
            <!-- توضیحات -->
            <div class="fCol jCenter aStart ih fullWidth">
              <span class="fRow jStart aCenter label"
                v-bind:class="{ready: showErrors && !descErr}">
                <i class="material-icons-round">credit_card</i>
                توضیحات کامل
              </span>
              <vue-editor v-model="desc" class="fullWidth"></vue-editor>
            </div>
          </div>
        </div>
        <div class="fRow jCenter aCenter fullWidth">
          <div class="bt fRow jCenter aCenter mini" @click="goGet('base')">
            <i class="material-icons-round">keyboard_arrow_right</i>
            <label>اصلاح اطلاعات اولیه</label>
          </div>
          <div class="bt fRow jCenter aCenter"
            @click="goGet('preview')"
            v-bind:class="{active: settingsErr}">
            <label>مرحلۀ بعدی - بررسی و ثبت نهایی</label>
            <i class="material-icons-round">keyboard_arrow_left</i>
          </div>
        </div>
      </div>
      <!-- step 7 -> setting -->
      <div class="bigInputHolder fullWidth fCol jCenter aCenter" v-if="step === 7">
        <div class="bigTitle fCol jCenter aCenter">
          <i class="material-icons-round">grading</i>
          <div class="t">بررسی و ثبت نهایی</div>
          <div class="d">اطلاعات را بررسی و ثبت کنید</div>
        </div>
        <div class="fullWidth form fCol jStart aCenter">
          <div class="dataRow fullWidth fCol jCenter aStart">
            <!-- s -->
          </div>
        </div>
        <div class="fRow jCenter aCenter fullWidth">
          <div class="bt fRow jCenter aCenter mini" @click="goGet('settings')">
            <i class="material-icons-round">keyboard_arrow_right</i>
            <label>اصلاح تنظیمات</label>
          </div>
          <div class="bt fRow jCenter aCenter"
            @click="createNewCourse"
            v-if="!editMode"
            v-bind:class="{active: true}">
            <label>ثبت دورۀ جدید</label>
            <i class="material-icons-round">keyboard_arrow_left</i>
          </div>
          <div class="bt fRow jCenter aCenter"
            @click="createNewCourse"
            v-if="editMode"
            v-bind:class="{active: true}">
            <label>ثبت تغییرات</label>
            <i class="material-icons-round">edit</i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';
import axios from 'axios';
import pBar from '@/components/pBar.vue';
import SwitchButton from '@/components/SwitchButton.vue';
import GetPhoto from '@/components/GetPhoto.vue';
import { VueEditor } from 'vue2-editor';

export default {
  mixins: [errorHandler, makeToast],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      // modes ↓
      loading: true,
      noContent: false,
      notFound: false,
      error: false,
      notYet: false,
      loaded: false,
      modeMsg: '',
      // modes ↑
      showErrors: true,
      editMode: false,
      steps: 7,
      step: 1,
      search: '',
      // last edits ↓
      fields: [
        {
          id: -1,
          title: 'کمی صبر کنید',
        },
      ],
      field: '',
      fieldErr: true,
      grades: [
        {
          id: -1,
          title: 'ابتدا رشته را انتخاب کنید',
        },
      ],
      grade: '',
      gradeErr: true,
      lessons: [
        {
          id: -1,
          title: 'ابتدا پایه را انتخاب کنید',
        },
      ],
      lesson: '',
      lessonErr: true,
      teachers: [
        {
          id: -1,
          title: 'ابتدا درس را انتخاب کنید',
        },
      ],
      teacher: '',
      teacherErr: true,
      // infos
      title: '',
      titleErr: true,
      duration: '',
      durationErr: true,
      discount: 0,
      discountErr: false,
      price: '',
      priceErr: true,
      status: true,
      free: false,
      shortDesc: '',
      shortDescErr: true,
      desc: '',
      descErr: true,
      cover: '',
      coverErr: true,
    };
  },
  methods: {
    setMode(m, msg) {
      this.noContent = false;
      this.loading = false;
      this.notYet = false;
      this.error = false;
      this.loaded = false;
      this.modeMsg = '';
      switch (m) {
        case 'loading': {
          this.loading = true;
          break;
        }
        case 'loaded': {
          this.loaded = true;
          break;
        }
        case 'error': {
          this.modeMsg = msg;
          this.error = true;
          break;
        }
        case 'notYet': {
          this.notYet = true;
          break;
        }
        case 'noContent': {
          this.noContent = true;
          break;
        }
        default:
          break;
      }
    },
    // dynamic fields
    getFields() {
      this.setMode('loading');
      const reqUrl = `${this.baseURL}/api/v${this.V}/Fields`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        const f = response.data.data;
        if (response.data.isSuccess) {
          this.setMode('loaded');
          this.step = 1;
          if (f.length === 0) {
            // if empty
          } else {
            // else make fields list
            this.fields = [];
            for (let i = 0; i < f.length; i += 1) {
              const item = {
                id: f[i].id,
                title: f[i].title,
              };
              this.fields.push(item);
            }
          }
        } else {
          this.setMode('error', 'خطا در دریافت رشته‌ها');
          this.makeToast('error', 'خطا در دریافت رشته‌ها', 3000);
          this.classFields = [
            {
              id: -1,
              title: 'خطا در دریافت رشته‌ها',
            },
          ];
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.setMode('error', this.errorHandler(error));
      }).catch(() => {
        this.setMode('error', 'مشکل فنی، با پشتیبانی تماس بگیرید');
        this.makeToast('error', 'مشکل فنی، با پشتیبانی تماس بگیرید', 3000);
      });
    },
    // dynamic grades
    getGrades(f) {
      this.setMode('loading');
      const reqUrl = `${this.baseURL}/api/v${this.V}/Grades?fieldId=${f}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.setMode('loaded');
          this.step = 2;
          const arr = response.data.data;
          this.grades = [];
          for (let i = 0; i < arr.length; i += 1) {
            this.grades.push({
              id: arr[i].id,
              title: arr[i].title,
              photo: arr[i].photo,
            });
          }
        } else {
          this.makeToast('error', 'خطا در دریافت پایه‌های تحصیلی', 3000);
          this.grades = [
            {
              id: -1,
              title: 'خطا در دریافت پایه‌ها',
            },
          ];
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
      }).catch(() => {
        this.makeToast('error', 'مشکل فنی، با پشتیبانی تماس بگیرید', 3000);
      });
    },
    // dynamic lessons
    getLessons(f) {
      this.setMode('loading');
      const reqUrl = `${this.baseURL}/api/v${this.V}/Lessons?gradeId=${f}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        this.setMode('loaded');
        this.step = 3;
        if (response.data.isSuccess) {
          this.lessons = [];
          const arr = response.data.data;
          for (let i = 0; i < arr.length; i += 1) {
            this.lessons.push({
              id: arr[i].id,
              title: arr[i].title,
              photo: arr[i].photo,
            });
          }
        } else {
          this.makeToast('error', 'خطا در دریافت درس‌ها', 3000);
          this.lessons = [
            {
              id: -1,
              title: 'خطا در دریافت درس‌ها',
            },
          ];
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      }).catch(() => {
        this.makeToast('error', 'مشکل فنی، با پشتیبانی تماس بگیرید', 3000);
      });
    },
    // get teachers
    getTeachers(f) {
      this.setMode('loading');
      const tpage = 1;
      // eslint-disable-next-line
      let reqUrl = `${this.baseURL}/api/v${this.V}/Teachers?type=1&query=${f}&pageNo=${tpage}&pageSize=${400}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        this.setMode('loaded');
        this.step = 4;
        if (response.data.isSuccess) {
          this.teachers = [];
          const arr = response.data.data.teachers;
          for (let i = 0; i < arr.length; i += 1) {
            this.teachers.push({
              id: arr[i].teacherId,
              title: arr[i].fullName,
              photo: arr[i].avatar,
              desc: arr[i].summary,
            });
          }
        } else {
          // this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      }).catch(() => {
        this.makeToast('error', 'مشکل فنی، با پشتیبانی تماس بگیرید', 3000);
      });
    },
    // select Items by type
    selectItem(type, e) {
      switch (type) {
        case 'field': {
          this.field = e;
          // console.log(this.field);
          break;
        }
        case 'grade': {
          this.grade = e;
          // console.log(this.grade);
          break;
        }
        case 'lesson': {
          this.lesson = e;
          // console.log(this.lesson);
          break;
        }
        case 'teacher': {
          this.teacher = e;
          // console.log(this.teacher);
          break;
        }
        default:
          break;
      }
    },
    goGet(sec) {
      switch (sec) {
        case 'field': {
          this.step = 1;
          this.getFields();
          break;
        }
        case 'grade': {
          if (!this.fieldErr) {
            this.getGrades(this.field.id);
          } else {
            this.makeToast('warning', 'ابتدا رشتۀ تحصیلی را انتخاب کنید', 3000);
          }
          break;
        }
        case 'lesson': {
          if (!this.gradeErr) {
            this.getLessons(this.grade.id);
          } else {
            this.makeToast('warning', 'ابتدا پایۀ تحصیلی را انتخاب کنید', 3000);
          }
          break;
        }
        case 'teacher': {
          if (!this.lessonErr) {
            this.getTeachers(this.lesson.id);
          } else {
            this.makeToast('warning', 'ابتدا درس را انتخاب کنید', 3000);
          }
          break;
        }
        case 'base': {
          if (!this.teacherErr) {
            this.step = 5;
          } else {
            this.makeToast('warning', 'ابتدا مدرّس را انتخاب کنید', 3000);
          }
          break;
        }
        case 'settings': {
          if (this.baseErr) {
            this.step = 6;
          } else {
            this.makeToast('warning', 'ابتدا اطلاعات اولیه را وارد کنید', 3000);
          }
          break;
        }
        case 'preview': {
          if (this.settingsErr) {
            this.step = 7;
          } else {
            this.makeToast('warning', 'ابتدا تنظمیات را وارد کنید', 3000);
          }
          break;
        }
        default:
          break;
      }
    },
    getUploaded(event) {
      this.cover = event;
    },
    commaSep(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    // create new course
    createNewCourse() {
      if (true) {
        axios({
          method: 'post',
          url: `${this.baseURL}/api/v${this.V}/Courses`,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            LessonId: this.lesson.id,
            gradeId: this.grade.id,
            teacherId: this.teacher.id,
            Photo: this.cover,
            Title: this.title,
            summary: this.shortDesc,
            Description: this.desc,
            DiscountPercent: this.free ? 0 : this.discount,
            Price: this.free ? 0 : parseInt(this.price.replace(/,/g, ''), 10),
            Duration: this.duration,
            Status: this.status,
            State: this.free ? 1 : 2,
          },
        }).then(
          (response) => {
            if (response.data.isSuccess) {
              // console.log(response.data);
              this.makeToast('success', 'دورۀ جدید با موفقیت ثبت شد.', 4000);
              this.$emit('refresh');
            } else {
              this.makeToast('warning', 'خطایی رخ داده است، لطفا ورودی‌ها را بررسی کنید.', 4000);
            }
          },
          (error) => {
            this.makeToast('error', this.errorHandler(error), 2000);
          },
        );
      }
    },
    // edit course
    editCourse() {
      if (true) {
        axios({
          method: 'put',
          url: `${this.baseURL}/api/v${this.V}/Courses/${this.editInitData.id}`,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            teacherId: this.teacher.id,
            Photo: this.cover,
            Title: this.title,
            summary: this.shortDesc,
            Description: this.desc,
            DiscountPercent: this.free ? 0 : this.discount,
            Price: this.free ? 0 : parseInt(this.price.replace(/,/g, ''), 10),
            Duration: this.duration,
            // Status: this.status,
            // State: this.free ? 1 : 2,
          },
        }).then(
          (response) => {
            if (response.data.isSuccess) {
              // console.log(response.data);
              this.makeToast('warning', 'دورۀ جدید با ویرایش شد ثبت شد.', 4000);
            } else {
              this.makeToast('warning', 'خطایی رخ داده است، لطفا ورودی‌ها را بررسی کنید.', 4000);
            }
          },
          (error) => {
            this.makeToast('error', this.errorHandler(error), 2000);
          },
        );
      }
    },
    // init edit
    initEdit() {
      const a = this.editInitData;
      this.field = {
        id: a.grade.field.id,
        title: a.grade.field.title,
      };
      this.grade = {
        id: a.grade.id,
        title: a.grade.title,
      };
      this.lesson = {
        id: a.lesson.id,
        title: a.lesson.title,
      };
      this.teacher = {
        id: a.teacherId,
        title: a.teacherFullName,
      };
      this.cover = a.photo;
      this.title = a.title;
      this.free = a.state === 1;
      this.price = this.commaSep(a.price);
      this.discount = a.discountPercent;
      this.desc = a.description;
      this.shortDesc = a.summary;
      this.duration = a.duration;
      this.status = a.status;
    },
  },
  components: {
    pBar,
    SwitchButton,
    GetPhoto,
    VueEditor,
  },
  watch: {
    step() {
      this.search = '';
    },
    field() {
      this.fieldErr = this.field === '';
    },
    grade() {
      this.gradeErr = this.grade === '';
    },
    lesson() {
      this.lessonErr = this.lesson === '';
    },
    teacher() {
      this.teacherErr = this.teacher === '';
    },
    title() {
      this.titleErr = this.title === '';
    },
    price() {
      // simple ↓
      // this.priceErr = this.price < 1;
      // complex ↓
      if (this.price.charAt(0) === '0') {
        this.price = this.price.substr(0, this.price.length - 1);
      }
      const a = this.price.replace(/,/g, '');
      this.price = this.commaSep(a);
      if (this.price.length > 4) {
        this.priceErr = false;
      } else {
        this.priceErr = true;
      }
      if (this.price.length > 10) {
        this.price = this.price.substr(0, 10);
        this.priceErr = false;
      }
    },
    discount() {
      if (this.discount === '') {
        this.discount = 0;
      }
      if (this.discount < 0) {
        this.discount = 0;
      }
      if (this.discount > 99) {
        this.discount = 99;
      }
      this.discountErr = (this.discount === ''
        || this.discount > 99
        || this.discount < 0);
    },
    cover() {
      this.coverErr = this.cover === '';
    },
    duration() {
      this.durationErr = this.duration === ''
        || this.duration < 0;
    },
    shortDesc() {
      this.shortDescErr = this.shortDesc === '';
    },
    desc() {
      this.descErr = this.desc === '';
    },
  },
  computed: {
    initImage() {
      let cii = 'none';
      if (!this.editMode) {
        return cii;
      }
      cii = this.cover;
      return cii;
    },
    baseErr() {
      const a = !this.titleErr
        && !this.coverErr;
      const b = this.free ? true : (!this.priceErr && !this.discountErr);
      return a && b;
    },
    settingsErr() {
      return !this.durationErr
        && !this.descErr
        && !this.shortDescErr;
    },
    editInitData() {
      return this.$store.state.courseEditData;
    },
    // filtereds
    filteredFields() {
      // eslint-disable-next-line
      return this.fields.filter((item) => item.title.toLowerCase().includes(this.search.toLowerCase()));
    },
    filteredGrades() {
      // eslint-disable-next-line
      return this.grades.filter((item) => item.title.toLowerCase().includes(this.search.toLowerCase()));
    },
    filteredLesson() {
      // eslint-disable-next-line
      return this.lessons.filter((item) => item.title.toLowerCase().includes(this.search.toLowerCase()));
    },
    filteredTeachers() {
      // eslint-disable-next-line
      return this.teachers.filter((item) => item.title.toLowerCase().includes(this.search.toLowerCase()));
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getFields();
      if (this.editInitData.id !== undefined) {
        this.editMode = true;
        // console.log('edit init: ', this.editInitData);
        this.initEdit();
      } else {
        this.editMode = false;
      }
      // this.setMode('loaded').lo;
    });
  },
};
</script>

<style lang="scss" scoped>
.courseForm {
  padding: 24px;
  border-radius: 16px;
  border: solid 1px rgba($color: #000000, $alpha: 0.05);
  .bt {
    padding: 8px 16px;
    border-radius: 64px;
    margin: 4px;
    cursor: pointer;
    background-color: rgba($color: #000000, $alpha: 0.05);
    * {
      pointer-events: none;
    }
    i {
      color: rgba($color: #000000, $alpha: 0.35);
    }
    label {
      font-weight: bold;
      font-size: 14px;
    }
  }
  .bt.mini {
    padding: 4px 8px;
    label {
      font-size: 12px;
    }
  }
  .bt.active {
    background-color: rgb(90, 224, 90);
    color: white;
    i {
      color: rgba($color: white, $alpha: 1);
    }
  }
  .title {
    padding-bottom: 16px;
    margin-bottom: 16px;
    border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.15);
    i {
      font-size: 48px;
      margin-left: 8px;
      opacity: 0.5;
    }
    .t {
      font-size: 18px;
      font-weight: 200;
      margin-bottom: 4px;
      text-align: right;
    }
    .d {
      font-size: 12px;
      font-weight: 200;
      text-align: right;
    }
    .stepper {
      padding: 8px 16px;
      border-radius: 24px;
      background-color: rgba($color: #000000, $alpha: 0.15);
      font-weight: bold;
      line-height: 1;
    }
  }
  .loading {
    padding: 32px 0;
    opacity: 0.5;
    @keyframes anim {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(-360deg);
      }
    }
    i {
      font-size: 24px;
      animation: anim 1s linear infinite;
    }
    span {
      font-size: 12px;
      margin-top: 4px;
    }
  }
  .bar {
    height: 4px;
    background-color: rgba($color: #000000, $alpha: 0.05);
    border-radius: 24px;
    margin-bottom: 24px;
    position: relative;
    .progress {
      right: 0;
      top: 0;
      bottom: 0;
      position: absolute;
      border-radius: 24px;
      background-color: rgba(106, 93, 163, 0.301);
      box-shadow: 0 0 16px 0px rgba($color: rgb(172, 153, 255), $alpha: 0);
      transition-duration: 0.5s;
      z-index: 3;
    }
    .progress.done {
      background-color: rgb(32, 170, 85);
      transition-duration: 0.8s;
      box-shadow: 0 0 24px 4px rgba($color: rgb(20, 255, 118), $alpha: 0.35);
      z-index: 5;
    }
    .progress.load {
      background-color: rgba($color: #000000, $alpha: 0.35);
    }
  }
  .wizard {
    .bigInputHolder {
      max-width: 800px;
      background-color: rgba($color: #000000, $alpha: 0);
      .bigTitle {
        margin-bottom: 16px;
        i {
          font-size: 32px;
          margin-bottom: 8px;
          opacity: 0.5;
        }
        .t {
          font-size: 18px;
          font-weight: 200;
          margin-bottom: 4px;
          text-align: right;
        }
        .d {
          font-size: 12px;
          font-weight: 200;
          text-align: right;
        }
      }
      .form {
        .ih {
          margin-bottom: 16px;
          span.label {
            opacity: 0.3;
            font-size: 14px;
            margin-bottom: 8px;
            i {
              margin-left: 8px;
              font-size: 16px;
            }
          }
          span.label.ready {
            opacity: 1 !important;
            * {
              color: rgb(35, 167, 35);
            }
          }
        }
      }
      .bigSearch {
        border-radius: 24px;
        padding: 8px 16px;
        outline: none;
        border: solid 2px rgba($color: #000000, $alpha: 0.1);
        font-size: 14px;
        font-weight: 200;
        text-align: center;
        resize: none;
      }
      .selectables {
        padding: 16px 0;
        border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.15);
        margin-bottom: 16px;
        .item {
          border-radius: 64px;
          padding: 8px 8px 8px 16px;
          cursor: pointer;
          margin: 4px;
          background-color: rgba($color: #000000, $alpha: 0.05);
          * {
            pointer-events: none;
          }
          .avatar {
            $w: 44px;
            width: $w;
            height: $w;
            min-width: $w;
            margin-left: 8px;
            border-radius: 64px;
            background-color: rgba($color: #000000, $alpha: 0.15);
            background-position: center;
            background-repeat: no-repeat;
            font-weight: bold;
            line-height: 1;
            background-size: cover;
          }
          label {
            font-size: 14px;
            font-weight: 300;
            line-height: 1;
            white-space: nowrap;
          }
          .desc {
            font-size: 10px;
            margin-top: 4px;
            line-height: 1;
            white-space: nowrap;
          }
        }
        .item:hover {
          background-color: rgba($color: #000000, $alpha: 0.1);
        }
        .item.selected {
          background-color: rgba($color: #417a45, $alpha: 1) !important;
          .avatar {
            color: white !important;
          }
          label {
            color: white;
          }
          .desc {
            color: white;
          }
        }
        .noContent {
          padding: 64px;
          border-radius: 48px;
          border: dashed 2px rgba($color: red, $alpha: 0.5);
          i {
            opacity: 0.25;
            font-size: 48px;
            margin-bottom: 8px;
          }
          span.big {
            font-size: 16px;
            font-weight: 500;
            text-align: center;
          }
          span.mini {
            font-size: 14px;
            font-weight: 100;
            text-align: center;
            a.inline {
              font-weight: bold;
              text-decoration: none;
              color: rgba($color: #3a73b4, $alpha: 1);
              display: inline;
            }
          }
          .clearFilter {
            padding: 4px 8px;
            margin-top: 16px;
            font-size: 12px;
            border-radius: 24px;
            font-weight: 300;
            color: white;
            cursor: pointer;
            background-color: rgba($color: #eb7d4b98, $alpha: 0.85);
          }
        }
      }
    }
  }
}
</style>
